import React from 'react';
import { useCreateCourseMapping, CreateCourseMappingPayload } from '../../data/useCreateCourseMapping';

export function useCreateCourseMappingActivity() {
  const { createCourseMapping } = useCreateCourseMapping();
  const [isBusy, setIsBusy] = React.useState(false);

  async function create(payload: CreateCourseMappingPayload) {
    setIsBusy(true);
    return createCourseMapping(payload)
      .then((result) => result)
      .finally(() => setIsBusy(false));
  }

  return {
    isBusy,
    create,
  };
}
